<template>
  <CRow>
    <CCol col="12" md="12" class="faq">
      <CCard>
        <CCardHeader>
          <strong>FAQ</strong>
        </CCardHeader>
        <CCardBody>
          <table class="table table-bordered table-striped">
            <thead>
              <tr>
                <th width="30px">No</th>
                <th width="30px">Urutan</th>
                <th width="300px">Question</th>
                <th width="500px">Answer</th>
                <th width="40px"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(v, k) in items" :key="k">
                <td>
                  <table-number
                    :page="paginate.page"
                    :size="paginate.size"
                    :index="k"
                  />
                </td>
                <td>{{ v.sort }}</td>
                <td>{{ v.question }}</td>
                <td v-html="v.answer"></td>
                <td>
                  <btn-edit @click="doEdit(v.id)" />
                </td>
              </tr>
            </tbody>
          </table>
        </CCardBody>
      </CCard>
      <div class="form-inline">
        <div class="col-md-4">
          <button class="btn btn-success btn2" @click="addFaq">Add Faq</button>
        </div>
        <div class="col-md-8">
          <content-pagination-2
            :paginator="paginate"
            class="right"
            style="padding: 10px 0"
            @change="getList"
          />
        </div>
      </div>
    </CCol>
  </CRow>
</template>
<script>
import ContentPagination2 from "../../components/ContentPagination2";
import BtnEdit from "../../components/BtnEdit";
import { HTTPAUTH } from "../../lib/httplib";
import TableNumber from "../../components/TableNumber.vue";
export default {
  components: { ContentPagination2, BtnEdit, TableNumber },
  name: "Collapses",
  data() {
    return {
      items: [],
      paginate: {},
    };
  },
  created() {
    this.getList(1);
  },
  methods: {
    addFaq() {
      this.$router.push({ path: "/faq/add/new" });
    },
    doEdit(id) {
      this.$router.push({ path: "/faq/add/" + id });
    },
    getList(page) {
      HTTPAUTH.get(`/api/admin/faq?page=${page}&size=10`).then((res) => {
        this.items = res.data.data;
        this.paginate = res.data.paginate;
      });
    },
    doShow(v) {
      console.log(v.show);
      v.show = !v.show;
    },
  },
};
</script>